import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import verified from '../assets/images/verified.svg';
import config from '../config/config';

const TipButton = ({ imageSrc, altText, text, userId, user, walletBalance }) => {
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState('');
  const [paymentOption, setPaymentOption] = useState('paystack');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [wordCount, setWordCount] = useState(0);
  const [toastMessage, setToastMessage] = useState('');
   const [toastType, setToastType] = useState('');

  useEffect(() => {
    setWordCount(message.length);
  }, [message]);

  useEffect(() => {
    if (toastMessage) {
      const timer = setTimeout(() => {
        setToastMessage('');
      }, 5000); 

      return () => clearTimeout(timer);
    }
  }, [toastMessage]);


  const handleOpenModal = () => {
    document.body.classList.add('modal-open-tip');
    setShowModal(true);
  };

  const handleCloseModal = () => {
    document.body.classList.remove('modal-open-tip');
    setShowModal(false);
    setAmount('');
    setMessage('');
    setPaymentOption('paystack');
  };

  const handlePayment = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    // Add transaction_id conditionally
    let transactionId = null;
  
    // Generate or get transaction_id based on payment method
    if (paymentOption !== 'userwallet') {
      // Generate a transaction ID for external payment methods
      transactionId = `${paymentOption}-${new Date().getTime()}`;
    }
  
    const tipData = {
      tip_to_user_id: userId,
      tip_amount: amount,
      tip_comment: message,
      payment_method: paymentOption,
      transaction_id: transactionId, // Add the transaction_id
    };
  
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${config.baseURL}/send-tip`, tipData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
  
      if (response.status === 200) {
        if (paymentOption === 'paystack') {
          await handlePaystackPayment(response.data);
        } else if (paymentOption === 'nowpayments') {
          await handleNowPayments(response.data.transaction_id);
        } else if (paymentOption === 'userwallet') {
          await handleWalletPayment();
        }
      }
    } catch (error) {
      setToastMessage('Failed to send tip. Please try again.');
      setToastType('error');
    } finally {
      setLoading(false);
    }
  };
  

const handleWalletPayment = async () => {
  try {
    await handleTransaction('userwallet');
    setToastMessage(`Tip sent to ${user.name} using wallet successfully!`);
    setToastType('success');
    handleCloseModal();
  } catch (error) {
    setToastMessage('Failed to process wallet payment. Please try again.');
    setToastType('error');
  }
};

const handlePaystackPayment = (responseData) => {
  const paystackConfig = {
    key: 'pk_test_6d954b11ef91c1d7a8911f46a866de5f37a5771a',
    email: responseData.email || 'default@example.com',
    amount: amount * 100, // Amount in kobo
    currency: 'NGN',
    reference: new Date().getTime().toString(),
    onClose: () => {
      // This runs when the payment modal is closed, but payment may not be complete
      console.log('Payment window closed');
      // Optionally show a message here or handle it elsewhere
    },
    onSuccess: (response) => {
      console.log('Payment successful:', response); // Debug statement
      handleTransaction('paystack', response.reference);

      // Show the success message once payment is successful
      setToastMessage(`Tip sent to ${user.name} successfully!`);
      setToastType('success');
      handleCloseModal(); // Close the modal here after successful payment
    },
  };

  // Close the tip modal before opening the Paystack iframe
  handleCloseModal();

  // Load the Paystack script if it hasn't been loaded yet
  if (!window.PaystackPop) {
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.onload = () => {
      window.PaystackPop.setup(paystackConfig).openIframe();
    };
    document.body.appendChild(script);
  } else {
    window.PaystackPop.setup(paystackConfig).openIframe();
  }
};


const handleNowPayments = async () => {
  console.log('Handling NowPayments'); // Debug statement

  const requestData = {
    price_amount: amount,
    price_currency: 'usd',
    pay_currency: 'btc',
    ipn_callback_url: 'https://yourwebsite.com/callback',
    order_id: `${userId}-${new Date().getTime()}`,
    order_description: `Tip for user ${userId}`,
  };

  try {
    const response = await axios.post(
      'https://api-sandbox.nowpayments.io/v1/payment',
      requestData,
      {
        headers: {
          'x-api-key': '11H5KAD-1NC4A54-NG25HG0-Y78N8BS',
          'Content-Type': 'application/json',
        }
      }
    );

    const { payment_url, payment_id } = response.data; 

    if (payment_url) {
      window.open(payment_url, '_blank');
      handleTransaction('nowpayments', payment_id);
      setToastMessage('Tip sent successfully!');
      setToastType('success');
      handleCloseModal(); // Close the modal after opening the payment URL
    } else {
      console.error('Failed to get payment URL');
      setToastMessage('Failed to get payment URL. Please try again.');
      setToastType('error');
    }
  } catch (error) {
    console.error('Error initiating NowPayments transaction:', error);
    setToastMessage('Error initiating payment. Please try again.');
    setToastType('error');
  }
};

  const getInitials = (name) => {
    const nameParts = name.split(' ');
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

  const handleTransaction = async (method, transactionId) => { 
    console.log(`Transaction with ${method}: ${transactionId}`);
    // Additional transaction handling can be added here
  };

  return (
    <div>
      <div onClick={handleOpenModal} className="tip-button" style={{ cursor: 'pointer' }}>
        <img src={imageSrc} alt={altText} className="tip-icon" />
        <span className="tip-text">{text}</span> 
      </div>

      {showModal && (
        <>
          <div className="modal-overlay" onClick={handleCloseModal} style={{ display: 'block' }}></div>
          <div className="modal restoreAccessModalAccess tip_popup fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="tipModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="tipModalLabel">Send Tip</h5> 
                </div>
                <div className="modal-body">
                  {user && (
                    <div className="client-info d-flex tip_popup">
                      <div className="client_info_left">
                        <div className="client-img">
                          <div className="lazy-container">
                            <a 
                              className={`user_pic_area ${user.status === 'active' ? 'user_online_status' : ''}`} 
                              href={`/${user.user_name}`}
                            >
                              {user.profile ? (
                                <img src={user.profile} alt={user.name} /> 
                              ) : (
                                <span>{getInitials(user.name)}</span>
                              )}
                            </a>
                          </div>
                        </div>
                        <div className="content"> 
                          <h6 className="name">
                            <a href={`/${user.user_name}`}>
                              {user.name}                              
                              <img className="image_margin_left padding_remove" src={verified} alt="Verified" />                        
                            </a>
                          </h6>
                          <span className="designation">
                            <a href={`/${user.user_name}`}>@{user.user_name}</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  <form id="sendTipForm" onSubmit={handlePayment}>
                    <div className="mb-2">
                        <div className="position_relative">
                          <div className="v-text-field__prefix">$</div>
                          <input
                            type="number"
                            className="form-control tip_amount"
                            id="amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder=""
                            required
                            min="5"
                          />
                          <label htmlFor="amount" className="placeholder-label tip_amount_only">Tip Amount</label>
                          <small className="minimum_amount">Minimum $5 USD</small>
                        </div>
                    </div>
                    <div className="mb-3">
                    <div className="form-group payment_method_label">
                      <label htmlFor="paymentOption">Select Payment Method</label>
                      <select
                        className="form-select"
                        id="paymentOption"
                        value={paymentOption}
                        onChange={(e) => setPaymentOption(e.target.value)}  // Update paymentOption state
                        required  // This ensures the user selects an option
                      >
                        {/* Payment options */}
                        <option value="paystack">Paystack</option>
                        <option value="nowpayments">NowPayments</option>
                        {walletBalance > 0 && (
                          <option value="userwallet">
                            Wallet Balance (${walletBalance})
                          </option>
                        )} {/* Only render Wallet option if balance is greater than 0 */}
                      </select>
                    </div>
                  </div>

                    <div className="mb-3">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Add a message (optional)"
                        value={message}
                        maxLength={1000}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      <div className="word-count word_count_tip_popup">
                        <span>{wordCount} / 1000</span>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary send_btn" onClick={handleCloseModal}> Cancel </button>
                      <button 
  type="submit" 
  className="btn send_btn btn-primary"
  disabled={loading} // Disable the button if loading is true
>
  {loading ? 'Processing...' : 'Send Tip'} 
</button>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

  

     {toastMessage && (
        <div className={`toastmessage ${toastType} ${toastMessage ? 'show' : ''}`}>
          {toastMessage}
        </div>
      )}


    </div>
  );
};

TipButton.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  user: PropTypes.shape({
    user_name: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    profile: PropTypes.string,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default TipButton;
